export default "__VITE_ASSET__e2ec1c43__"